import { render, staticRenderFns } from "./sendBack.vue?vue&type=template&id=73c48e6e&scoped=true"
import script from "./sendBack.vue?vue&type=script&lang=js"
export * from "./sendBack.vue?vue&type=script&lang=js"
import style0 from "./sendBack.vue?vue&type=style&index=0&id=73c48e6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c48e6e",
  null
  
)

export default component.exports